import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'
import sequenceDateConflictTesters from 'const/sequenceDateConflictTesters'
import childDateConflictTesters from 'const/childDateConflictTesters'

const makeGetErrorsForDate = (card, boardsById, cardsById, cardStatusesById) => (
  isCardA,
  cardDates,
  testers,
) =>
  cardDates.reduce((acc, cardDate) => {
    if (
      !cardsById[cardDate.id]?.isArchived &&
      !cardsById[cardDate.id]?.isTemplate &&
      !boardsById[cardsById[cardDate.id]?.boardId]?.isClosed &&
      cardStatusesById[cardsById[cardDate.id]?.statusId] !== undefined &&
      cardStatusesById[cardsById[cardDate.id]?.statusId] !== CardStatusRoles.NONE &&
      cardStatusesById[cardsById[cardDate.id]?.statusId] !== CardStatusRoles.COMPLETED
    ) {
      let relationError

      testers.forEach(conflictTester => {
        const error = conflictTester.test(
          isCardA ? card : cardDate,
          isCardA ? cardDate : card,
        )

        if (error) {
          if (!relationError) relationError = acc.find(relationError => relationError.cardId === cardDate.id && relationError.relationType === error.relationType)

          if (!relationError) {
            relationError = {
              cardId: cardDate.id,
              relationType: error.relationType,
              errors: [],
            }

            if (error.relationType === 'sequence') {
              relationError.prevId = isCardA ? card.id : cardDate.id
              relationError.nextId = isCardA ? cardDate.id : card.id
            } else if (error.relationType === 'child') {
              relationError.parentId = isCardA ? card.id : cardDate.id
              relationError.childId = isCardA ? cardDate.id : card.id
            }

            acc.push(relationError)
          }

          relationError.errors.push(error)
        }
      })
    }

    return acc
  }, [])

const createCardDateConflictsSelector = () => {
  return createSelector<{ cardId, boardsById, cardsById, cardStatusesById }, any, any>(
    [
      ({ cardId }) => cardId,
      ({ boardsById }) => boardsById,
      ({ cardsById }) => cardsById,
      ({ cardStatusesById }) => cardStatusesById,
    ],
    (
      id,
      boardsById,
      cardsById,
      cardStatusesById,
    ) => {
      const card = cardsById[id]

      if (
        !card ||
        card.isArchived ||
        card.isTemplate ||
        boardsById[card.boardId]?.isClosed || 
        cardStatusesById[card.statusId]?.role === CardStatusRoles.NONE ||
        cardStatusesById[card.statusId]?.role === CardStatusRoles.COMPLETED
      ) {
        return []
      }

      const getErrorsForDate = makeGetErrorsForDate({ id, startDate: card.startDate, dueDate: card.dueDate }, boardsById, cardsById, cardStatusesById)

      return [
        ...getErrorsForDate(
          false,
          card.prevCardDates,
          sequenceDateConflictTesters,
        ),
        ...getErrorsForDate(
          true,
          card.nextCardDates,
          sequenceDateConflictTesters,
        ),
        ...getErrorsForDate(
          false,
          card.ancestorCardsDates,
          childDateConflictTesters,
        ),
        ...getErrorsForDate(
          true,
          card.descendantCardsDates,
          childDateConflictTesters,
        ),
      ]
    }
  )
}

export default createCardDateConflictsSelector
